module.exports = __webpack_public_path__ + "a387953cafbb404bc78e24009bf3d85c.MP3";